import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {StyledButtonContent} from '../Button'
import {InputButtonStyledContainer} from '../helpers/InputButton'

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** If the buttons are stacked vertically  */
  isVertical?: boolean
  /** The list of Buttons or InputButtons */
  children?: React.ReactNode
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string
}

const ButtonGroupStyled = styled('div')`
  display: flex;
  > button {
    position: relative;
  }
  > button:hover {
    z-index: 1;
  }
  > button:active {
    z-index: 1;
  }
  > button:focus {
    z-index: 2;
  }
  > button ${InputButtonStyledContainer}, > button ${StyledButtonContent} {
    box-shadow: none;
  }
  &.--is-horizontal {
    flex-direction: row;

    > button:not(:last-of-type)
      ${InputButtonStyledContainer},
      > button:not(:last-of-type)
      ${StyledButtonContent} {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    > button:not(:first-of-type)
      ${InputButtonStyledContainer},
      > button:not(:first-of-type)
      ${StyledButtonContent} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    > button:not(:first-of-type) {
      margin-left: -1px;
    }
  }
  &.--is-vertical {
    flex-direction: column;
    align-items: flex-start;
    > button:not(:last-of-type)
      ${InputButtonStyledContainer},
      > button:not(:last-of-type)
      ${StyledButtonContent} {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    > button:not(:first-of-type)
      ${InputButtonStyledContainer},
      > button:not(:first-of-type)
      ${StyledButtonContent} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    > button:not(:first-of-type) {
      margin-top: -1px;
    }
  }
`

export const ButtonGroup = ({
  isVertical = false,
  children,
  className,
  dataId
}: Props) => {
  return (
    <ButtonGroupStyled
      data-id={dataId}
      className={cx(
        isVertical && '--is-vertical',
        !isVertical && '--is-horizontal',
        className
      )}
    >
      {children}
    </ButtonGroupStyled>
  )
}
